import { a as l } from "./chunk-BaseElement-CJM6sCUz.js";
import { t as h } from "./chunk-custom-element-CN0MC8o7.js";
import { n as c } from "./chunk-property---aaewZr.js";
var b = Object.defineProperty, f = Object.getOwnPropertyDescriptor, o = (s, e, r, a) => {
  for (var t = a > 1 ? void 0 : a ? f(e, r) : e, n = s.length - 1, i; n >= 0; n--)
    (i = s[n]) && (t = (a ? i(e, r, t) : i(t)) || t);
  return a && t && b(e, r, t), t;
};
let d = class extends l {
  connectedCallback() {
    super.connectedCallback(), this.shuffleBrands(), this.renderBrands();
  }
  shuffleBrands() {
    if (this.brandsString && (this.brandsArr = JSON.parse(this.brandsString), !(!this.brandsArr || !this.brandsArr.length))) {
      for (let s = this.brandsArr.length - 1; s > 0; s--) {
        const e = Math.floor(Math.random() * (s + 1));
        [this.brandsArr[s], this.brandsArr[e]] = [
          this.brandsArr[e],
          this.brandsArr[s]
        ];
      }
      this.brandsArr = this.brandsArr.slice(0, 5);
    }
  }
  renderBrands() {
    const s = [];
    this.brandsArr.forEach((r) => {
      const a = r.replace(" ", "-").toLowerCase(), t = this.querySelector(`[data-handle='${a}']`);
      t && s.push(t);
    }), this.querySelectorAll("[data-brand]").forEach((r) => {
      (r.classList.contains("hidden") || r.classList.contains("invisible")) && r.remove();
    }), s.forEach((r) => {
      this.appendChild(r), r.classList.remove("hidden");
    }), this.classList.remove("opacity-0");
  }
};
o([
  c({ type: String, attribute: "data-brands" })
], d.prototype, "brandsString", 2);
d = o([
  h("brand-selector")
], d);
export {
  d as BrandSelector
};
